export const SET_TOKEN = "SET_TOKEN";
export const USER_ROLE = "USER_ROLE";
export const LOGGED_IN_USER_ID = "LOGGED_IN_USER_ID";
export const LOG_OUT = "LOG_OUT";
export const SET_PROFILE_DATA= "SET_PROFILE_DATA"
